import {
  S3UploadType,
  Task,
  TaskGuest,
  TaskSignatureStatus,
} from '@admiin-com/ds-graphql';
import { WBDialog, WBFlex, WBIconButton, WBImage } from '@admiin-com/ds-web';
import { useRef } from 'react';
import { useDocumentUrl } from '../../hooks/useDocumentUrl/useDocumentUrl';
import PdfViewer from '../PdfViewer/PdfViewer';
import { useGetTask } from '../../features/hooks/useGetTask/useGetTask';

export interface PdfViewModalProps {
  open: boolean;
  onClose: () => void;
  task?: TaskGuest | null | undefined | Task;
  annotations?: any;
  documentUrl?: string;
  isImage?: boolean;
}

export function PdfViewModal({
  open,
  annotations,
  onClose,
  documentUrl: documentUrlProps,
  task,
  isImage: isImageProps,
}: PdfViewModalProps) {
  const { documentUrl: documentUrlFromTask } = useDocumentUrl(task);
  const documentUrl = documentUrlProps ?? documentUrlFromTask;
  const pdfSignatureRef = useRef(null);
  const { task: realTask } = useGetTask({
    id: task?.id ?? null,
    forceRefresh: true,
  });
  const updatingAnnotions = annotations ?? realTask?.annotations;

  const isImage =
    isImageProps ?? (task as Task)?.documents?.[0]?.type === S3UploadType.IMAGE;

  return (
    <WBDialog
      open={open}
      maxWidth={'sm'}
      fullWidth
      sx={{ '& .MuiPaper-root': { overflow: 'visible' } }}
    >
      <WBFlex
        flexDirection={'row'}
        height={'70vh'}
        overflow={'visible'}
        position={'relative'}
      >
        <WBFlex flex={1}>
          {documentUrl ? (
            isImage ? (
              <WBImage src={documentUrl} responsive />
            ) : (
              <PdfViewer
                ref={pdfSignatureRef ?? null}
                annotations={
                  task?.signatureStatus === TaskSignatureStatus.SIGNED
                    ? ''
                    : updatingAnnotions ?? ''
                }
                documentUrl={documentUrl}
              />
            )
          ) : null}
        </WBFlex>
        <WBIconButton
          aria-label="close"
          icon="Close"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          sx={{
            position: 'absolute',
            right: -40,
            top: -40,
            color: (theme) => theme.palette.grey[500],
          }}
        />
      </WBFlex>
    </WBDialog>
  );
}

export default PdfViewModal;
